export default {
      id: "icon--what-small-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--what-small-usage",
      toString: function () {
        return this.url;
      }
    }